import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber
  } from "../../commonFunctions";
  
  const ms903 = {
    label: "Product Documents",
    starting: true,
    url: "ms903",
    pageLabel: "Product Documents",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Product Group",
            name: "",
            description: "Enter Product Group"
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Individual",
                value: "individual"
              },
              {
                label: "Deposit",
                value: "Deposit"
              },
              {
                label: "Loan",
                value: "Loan"
              },
              {
                label: "Bank",
                value: "Bank"
              },
              {
                label: "Other",
                value: "other"
              }
            ],
            placeHolder: "Product Group",
            name: "ProductGroup",
            description: "Enter Product Group"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Product Type",
            name: "",
            description: "Enter Product Type"
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Individual",
                value: "individual"
              },
              {
                label: "Internal",
                value: "internal"
              },
              {
                label: "Other",
                value: "other"
              }
            ],
      
            placeHolder: "Product Type",
            name: "ProductType",
            description: "Enter Product Type"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Product",
            name: "",
            description: ""
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "",
            name: "product",
            description: ""
          },
          {
            inputType: "showdata",
            data: "product",
            textcolor: "black",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            }
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "No of Records",
            name: "",
            description: "Enter Records"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            name: "Records",
            description: ""
          },

    ]
}
export default ms903